module.exports = __webpack_public_path__ + "media/images/premium/icon-cross-circle-281309f230156380989be3cc2aac5a32.svg";